export default {
  STANDALONE_MAP: "mapbox://styles/gacilu/cjs35j81q157i1fo8t8ronku5",
  MAP_WITH_MARKERS: "mapbox://styles/gacilu/cjs35j81q157i1fo8t8ronku5",
  SATELLITE: "mapbox://styles/mapbox/satellite-v9",
  STREET_SATELLITE: "mapbox://styles/mapbox/satellite-streets-v10"
};
